module.exports = __webpack_public_path__ + "static/media/pexels-manuel-geissinger-325229_3.baf2be5f.jpg";